import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../components/ui/Button";

const QuickActions = () => {
  const quickActions = [
    {
      label: "Create New Event",
      description: "Start tracking expenses for a new group activity",
      icon: "Plus",
      variant: "default",
      path: "/create-event",
      primary: true,
    },
    {
      label: "Settle Balances",
      description: "Pay or request money from friends",
      icon: "DollarSign",
      variant: "outline",
      action: "settle",
      primary: false,
    },
    {
      label: "View All Events",
      description: "Browse your complete event history",
      icon: "List",
      variant: "ghost",
      action: "viewAll",
      primary: false,
    },
  ];

  const handleAction = (action) => {
    switch (action) {
      case "settle":
        // Handle settle balances action
        console.log("Settle balances clicked");
        break;
      case "viewAll":
        // Handle view all events action
        console.log("View all events clicked");
        break;
      default:
        break;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold text-foreground">
            Quick Actions
          </h2>
          <p className="text-sm text-muted-foreground">
            Get started with common tasks
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {quickActions?.map((action, index) => (
          <div key={index} className="group">
            {action?.path ? (
              <Link to={action?.path} className="block">
                <div
                  className={`p-4 rounded-lg border transition-all duration-200 hover:shadow-subtle ${
                    action?.primary
                      ? "border-primary bg-primary/5 hover:bg-primary/10"
                      : "border-border hover:border-primary/20"
                  }`}
                >
                  <div className="flex items-start space-x-3">
                    <div
                      className={`p-2 rounded-md ${
                        action?.primary
                          ? "bg-primary text-primary-foreground"
                          : "bg-muted text-muted-foreground group-hover:bg-primary group-hover:text-primary-foreground"
                      } transition-colors`}
                    >
                      <Button
                        variant="ghost"
                        size="icon"
                        iconName={action?.icon}
                        className="w-5 h-5 p-0"
                      />
                    </div>
                    <div className="flex-1">
                      <h3
                        className={`font-medium mb-1 ${
                          action?.primary ? "text-primary" : "text-foreground"
                        } group-hover:text-primary transition-colors`}
                      >
                        {action?.label}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {action?.description}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ) : (
              <button
                onClick={() => handleAction(action?.action)}
                className="w-full text-left"
              >
                <div
                  className={`p-4 rounded-lg border transition-all duration-200 hover:shadow-subtle ${
                    action?.primary
                      ? "border-primary bg-primary/5 hover:bg-primary/10"
                      : "border-border hover:border-primary/20"
                  }`}
                >
                  <div className="flex items-start space-x-3">
                    <div
                      className={`p-2 rounded-md ${
                        action?.primary
                          ? "bg-primary text-primary-foreground"
                          : "bg-muted text-muted-foreground group-hover:bg-primary group-hover:text-primary-foreground"
                      } transition-colors`}
                    >
                      <Button
                        variant="ghost"
                        size="icon"
                        iconName={action?.icon}
                        className="w-5 h-5 p-0"
                      />
                    </div>
                    <div className="flex-1">
                      <h3
                        className={`font-medium mb-1 ${
                          action?.primary ? "text-primary" : "text-foreground"
                        } group-hover:text-primary transition-colors`}
                      >
                        {action?.label}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {action?.description}
                      </p>
                    </div>
                  </div>
                </div>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
